<template>
    <div class="error-message">{{ message }}</div>
</template>

<script>
export default {
    props: ["message"],
};
</script>

<style lang="less" scoped>
.error-message {
    font-size: 14px;
    color: #FF384C;
}
</style>
